import {z} from 'zod'

export const SubscriptionFeatures = z.object({
  maxActiveProjects: z.number().min(0),
  maxActiveConnections: z.number().min(0),
  manualTimeEntryCreation: z.boolean(),
  recommendationRefresh: z.object({
    automaticInterval: z.enum(['never', 'daily', 'hourly']),
    allowManual: z.boolean(),
  }),
})
export type SubscriptionFeatures = z.infer<typeof SubscriptionFeatures>
